import type { ZudokuConfig } from 'zudoku';
import { HeaderMenu } from './pages/docs/en/HeaderMenu';

const config: ZudokuConfig = {
  slots: {
    //'head-navigation-end': HeaderMenu,
    'top-navigation-side': HeaderMenu,
  },
  site: {
    title: 'Otonum Developer Documentation',
    showPoweredBy: false,
    // banner: {
    //   message: 'Welcome to our beta documentation!',
    //   color: 'info', // 'note' | 'tip' | 'info' | 'caution' | 'danger' or custom
    //   dismissible: true,
    // },
    footer: {
      // Footer configuration goes here
      position: 'center',
      copyright: `© ${new Date().getFullYear()} Vertical Ascendant Inc. All Rights Reserved`,
      // Other options...
      columns: [
        {
          title: 'Product',
          position: 'center', // position in grid, optional: start, center, end
          links: [
            { label: 'Otonum Rewards', href: 'https://rewards.otonum.io/' },
            { label: 'Otonum Insights', href: 'https://insights.otonum.io/' },
            { label: 'Pricing', href: 'https://otonum.io/#pricing' },
          ],
        },
        {
          title: 'Company',
          links: [
            {
              label: 'About',
              href: 'https://verticalascendant.com/en/#vision',
            },
            { label: 'Blog', href: 'https://verticalascendant.com/en/blog/' },
            { label: 'Contact', href: 'mailto:contact@otonum.io' },
          ],
        },
      ],
      social: [
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="size-5"
              fill="currentColor"
              aria-label="LinkedIn"
            >
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          ),
          href: 'https://www.linkedin.com/showcase/otonum-officiel',
        },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="size-5"
              fill="currentColor"
              aria-label="Facebook"
            >
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
          ),
          href: 'https://www.facebook.com/share/1B9zCtVDoq/?mibextid=wwXIfr',
        },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="size-5"
              fill="currentColor"
              aria-label="Instagram"
            >
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12c0 3.259.014 3.668.072 4.948.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24c3.259 0 3.668-.014 4.948-.072 1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.689.072-4.948 0-3.259-.014-3.667-.072-4.947-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          ),
          href: 'https://www.instagram.com/otonum.io?igsh=MTdwcnBjMm1jZTkwbQ%3D%3D&utm_source=qr',
        },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="size-5"
              fill="currentColor"
              aria-label="TikTok"
            >
              <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
            </svg>
          ),
          href: 'https://www.tiktok.com/@otonomuofficiel?_r=1&_t=ZS-94QVAplqM7D',
        },
      ],
    },
    logo: {
      src: { light: '/logo-otonum-v.png', dark: '/logo-otonum-v.png' },
      alt: 'Otonum',
      width: '150px',
    },
  },
  navigation: [
    // ─── English Documentation ───────────────────────────────────────────────
    {
      type: 'category',
      label: 'Documentation',
      display: () =>
        typeof window === 'undefined' ||
        (!window.location.pathname.startsWith('/docs/fr') &&
          !window.location.pathname.startsWith('/timeline/fr') &&
          !window.location.pathname.startsWith('/api/fr')),
      items: [
        {
          type: 'category',
          label: 'Getting Started',
          icon: 'sparkles',
          items: [
            {
              type: 'doc',
              file: '/docs/en/introduction',
              label: 'About Otonum',
              icon: 'info',
            },
            {
              type: 'doc',
              file: '/docs/en/quick-start',
              label: 'Quick Start',
              icon: 'zap',
            },
            {
              type: 'doc',
              file: '/docs/en/authentication',
              label: 'Authentication',
              icon: 'key',
            },
          ],
        },
        {
          type: 'category',
          label: 'Concepts',
          icon: 'book-open',
          items: [
            {
              type: 'doc',
              file: '/docs/en/consumer-identity',
              label: 'Member Identity',
              icon: 'user',
            },
            {
              type: 'doc',
              file: '/docs/en/loyalty-program',
              label: 'Loyalty Program',
              icon: 'gift',
            },
            {
              type: 'doc',
              file: '/docs/en/campaigns',
              label: 'Campaigns',
              icon: 'target',
            },
            {
              type: 'doc',
              file: '/docs/en/rules-triggers',
              label: 'Rules & Triggers',
              icon: 'filter',
            },
            {
              type: 'doc',
              file: '/docs/en/vouchers',
              label: 'Vouchers',
              icon: 'ticket',
            },
            {
              type: 'doc',
              file: '/docs/en/activities',
              label: 'Recording Activities',
              icon: 'activity',
            },
            {
              type: 'doc',
              file: '/docs/en/transactions',
              label: 'Transactions',
              icon: 'list',
            },
            {
              type: 'doc',
              file: '/docs/en/rewards',
              label: 'Rewards',
              icon: 'star',
            },
            {
              type: 'doc',
              file: '/docs/en/consumer-consent',
              label: 'Consent',
              icon: 'shield',
            },
            {
              type: 'doc',
              file: '/docs/en/referral-codes',
              label: 'Referral Codes',
              icon: 'share-2',
            },
            {
              type: 'doc',
              file: '/docs/en/wallet',
              label: 'Wallet & Merchant Isolation',
              icon: 'wallet',
            },
            {
              type: 'doc',
              file: '/docs/en/request-format',
              label: 'Request Format',
              icon: 'code',
            },
          ],
        },
        {
          type: 'category',
          label: 'Integration',
          icon: 'plug',
          items: [
            {
              type: 'doc',
              file: '/docs/en/integration-guide',
              label: 'Integration Guide',
              icon: 'cable',
            },
            {
              type: 'doc',
              file: '/docs/en/consent-management',
              label: 'Consent Management',
              icon: 'clipboard-check',
            },
            {
              type: 'doc',
              file: '/docs/en/app-settings',
              label: 'Application Settings',
              icon: 'settings',
            },
            {
              type: 'doc',
              file: '/docs/en/task-status',
              label: 'Task Status',
              icon: 'loader',
            },
            {
              type: 'link',
              icon: 'folder-cog',
              badge: { label: 'New', color: 'purple' },
              label: 'API Reference',
              to: '/api/en',
            },
          ],
        },
        {
          type: 'category',
          label: 'Resources',
          icon: 'life-buoy',
          items: [
            {
              type: 'doc',
              file: '/docs/en/best-practices',
              label: 'Best Practices',
              icon: 'shield-check',
            },
            {
              type: 'doc',
              file: '/docs/en/error-codes',
              label: 'Error Codes',
              icon: 'alert-triangle',
            },
            {
              type: 'doc',
              file: '/docs/en/glossary',
              label: 'Glossary',
              icon: 'book',
            },
            {
              type: 'doc',
              file: '/docs/en/faq',
              label: 'Integration FAQ',
              icon: 'help-circle',
            },
          ],
        },
      ],
    },
    // ─── French Documentation ────────────────────────────────────────────────
    {
      type: 'category',
      label: 'Documentation',
      display: () =>
        typeof window !== 'undefined' &&
        (window.location.pathname.startsWith('/docs/fr') ||
          window.location.pathname.startsWith('/timeline/fr') ||
          window.location.pathname.startsWith('/api/fr')),
      items: [
        {
          type: 'category',
          label: 'Premiers pas',
          icon: 'sparkles',
          items: [
            {
              type: 'doc',
              file: '/docs/fr/introduction',
              label: "À propos d'Otonum",
              icon: 'info',
            },
            {
              type: 'doc',
              file: '/docs/fr/quick-start',
              label: 'Démarrage rapide',
              icon: 'zap',
            },
            {
              type: 'doc',
              file: '/docs/fr/authentication',
              label: 'Authentification',
              icon: 'key',
            },
          ],
        },
        {
          type: 'category',
          label: 'Concepts',
          icon: 'book-open',
          items: [
            {
              type: 'doc',
              file: '/docs/fr/consumer-identity',
              label: 'Identité client',
              icon: 'user',
            },
            {
              type: 'doc',
              file: '/docs/fr/loyalty-program',
              label: 'Programme de fidélité',
              icon: 'gift',
            },
            {
              type: 'doc',
              file: '/docs/fr/campaigns',
              label: 'Campagnes',
              icon: 'target',
            },
            {
              type: 'doc',
              file: '/docs/fr/rules-triggers',
              label: 'Règles & Triggers',
              icon: 'filter',
            },
            {
              type: 'doc',
              file: '/docs/fr/vouchers',
              label: "Bon d'achat",
              icon: 'ticket',
            },
            {
              type: 'doc',
              file: '/docs/fr/activities',
              label: 'Enregistrer des activités',
              icon: 'activity',
            },
            {
              type: 'doc',
              file: '/docs/fr/transactions',
              label: 'Transactions',
              icon: 'list',
            },
            {
              type: 'doc',
              file: '/docs/fr/rewards',
              label: 'Récompenses',
              icon: 'star',
            },
            {
              type: 'doc',
              file: '/docs/fr/consumer-consent',
              label: 'Consentement',
              icon: 'shield',
            },
            {
              type: 'doc',
              file: '/docs/fr/referral-codes',
              label: 'Codes de parrainage',
              icon: 'share-2',
            },
            {
              type: 'doc',
              file: '/docs/fr/wallet',
              label: 'Wallet & isolation par marchand',
              icon: 'wallet',
            },
            {
              type: 'doc',
              file: '/docs/fr/request-format',
              label: 'Format des requêtes',
              icon: 'code',
            },
          ],
        },
        {
          type: 'category',
          label: 'Intégration',
          icon: 'plug',
          items: [
            {
              type: 'doc',
              file: '/docs/fr/integration-guide',
              label: "Guide d'intégration",
              icon: 'cable',
            },
            {
              type: 'doc',
              file: '/docs/fr/consent-management',
              label: 'Gestion du consentement',
              icon: 'clipboard-check',
            },
            {
              type: 'doc',
              file: '/docs/fr/app-settings',
              label: "Paramètres de l'application",
              icon: 'settings',
            },
            {
              type: 'doc',
              file: '/docs/fr/task-status',
              label: 'Statut des tâches',
              icon: 'loader',
            },
            {
              type: 'link',
              icon: 'folder-cog',
              badge: { label: 'Nouveau', color: 'purple' },
              label: 'Référence API',
              to: '/api/fr',
            },
          ],
        },
        {
          type: 'category',
          label: 'Ressources',
          icon: 'life-buoy',
          items: [
            {
              type: 'doc',
              file: '/docs/fr/best-practices',
              label: 'Bonnes pratiques',
              icon: 'shield-check',
            },
            {
              type: 'doc',
              file: '/docs/fr/error-codes',
              label: "Codes d'erreur",
              icon: 'alert-triangle',
            },
            {
              type: 'doc',
              file: '/docs/fr/glossary',
              label: 'Glossaire',
              icon: 'book',
            },
            {
              type: 'doc',
              file: '/docs/fr/faq',
              label: 'FAQ intégration',
              icon: 'help-circle',
            },
          ],
        },
      ],
    },
    // ─── Top-level nav links ─────────────────────────────────────────────────
    {
      type: 'link',
      to: '/api/en',
      label: 'API Reference',
      display: () =>
        typeof window === 'undefined' ||
        (!window.location.pathname.startsWith('/docs/fr') &&
          !window.location.pathname.startsWith('/timeline/fr') &&
          !window.location.pathname.startsWith('/api/fr')),
    },
    {
      type: 'link',
      to: '/api/fr',
      label: 'Référence API',
      display: () =>
        typeof window !== 'undefined' &&
        (window.location.pathname.startsWith('/docs/fr') ||
          window.location.pathname.startsWith('/timeline/fr') ||
          window.location.pathname.startsWith('/api/fr')),
    },
    {
      type: 'link',
      to: '/timeline/en/changelog',
      label: 'Changelog',
      display: () =>
        typeof window === 'undefined' ||
        (!window.location.pathname.startsWith('/docs/fr') &&
          !window.location.pathname.startsWith('/timeline/fr') &&
          !window.location.pathname.startsWith('/api/fr')),
    },
    {
      type: 'link',
      to: '/timeline/fr/changelog',
      label: 'Journal des changements',
      display: () =>
        typeof window !== 'undefined' &&
        (window.location.pathname.startsWith('/docs/fr') ||
          window.location.pathname.startsWith('/timeline/fr') ||
          window.location.pathname.startsWith('/api/fr')),
    },
  ],
  redirects: [
    { from: '/docs/en', to: '/docs/en/introduction' },
    { from: '/docs', to: '/docs/en/introduction' },
    { from: '/docs/fr', to: '/docs/fr/introduction' },
    { from: '/timeline/en', to: '/timeline/en/changelog' },
    { from: '/timeline', to: '/timeline/en/changelog' },
    { from: '/timeline/fr', to: '/timeline/fr/changelog' },
    { from: '/api', to: '/api/en' },
  ],
  apis: [
    {
      type: 'file',
      input: './apis/openapi.yaml',
      path: '/api/en',
    },
    {
      type: 'file',
      input: './apis/openapi.fr.yaml',
      path: '/api/fr',
    },
  ],
  docs: {
    files: '/pages/**/*.mdx',
    defaultOptions: {
      copyPage: false, // Enable copy button for all pages
    },
  },
  metadata: {
    title: 'Otonum Developer Documentation',
    description:
      'Official API documentation for Otonum — the AI-powered loyalty and rewards platform by Vertical Ascendant. Integrate points, cashback, and vouchers into your existing systems.',
    logo: 'https://otonum.io/assets/img/otonum-01-1.png',
    favicon: 'https://otonum.io/favicon.ico',
    applicationName: 'Otonum Developer Docs',
    referrer: 'no-referrer',
    keywords: [
      'loyalty',
      'rewards',
      'API',
      'cashback',
      'points',
      'vouchers',
      'customer retention',
      'Otonum',
      'Vertical Ascendant',
    ],
    authors: ['Vertical Ascendant Inc.'],
    creator: 'Vertical Ascendant Inc.',
    publisher: 'Vertical Ascendant Inc.',
  },
  theme: {
    light: {
      background: 'oklch(1.00 0 0)',
      foreground: 'oklch(0.27 0 0)',
      card: 'oklch(1.00 0 0)',
      cardForeground: 'oklch(0.27 0 0)',
      popover: 'oklch(1.00 0 0)',
      popoverForeground: 'oklch(0.27 0 0)',
      primary: 'oklch(0.60 0.24 300)',
      primaryForeground: 'oklch(1.00 0 0)',
      secondary: 'oklch(0.97 0.00 264.54)',
      secondaryForeground: 'oklch(0.45 0.03 256.80)',
      muted: 'oklch(0.98 0.00 247.84)',
      mutedForeground: 'oklch(0.55 0.02 264.36)',
      accent: 'oklch(0.96 0.04 300)',
      accentForeground: 'oklch(0.40 0.22 300)',
      destructive: 'oklch(0.64 0.21 25.33)',
      destructiveForeground: 'oklch(1.00 0 0)',
      border: 'oklch(0.93 0.01 264.53)',
      input: 'oklch(0.93 0.01 264.53)',
      ring: 'oklch(0.60 0.24 300)',
      radius: '0.375rem',
    },
    dark: {
      background: 'oklch(0.20 0 0)',
      foreground: 'oklch(0.92 0 0)',
      card: 'oklch(0.27 0 0)',
      cardForeground: 'oklch(0.92 0 0)',
      popover: 'oklch(0.27 0 0)',
      popoverForeground: 'oklch(0.92 0 0)',
      primary: 'oklch(0.65 0.24 300)',
      primaryForeground: 'oklch(1.00 0 0)',
      secondary: 'oklch(0.27 0 0)',
      secondaryForeground: 'oklch(0.92 0 0)',
      muted: 'oklch(0.27 0 0)',
      mutedForeground: 'oklch(0.72 0 0)',
      accent: 'oklch(0.35 0.18 300)',
      accentForeground: 'oklch(0.92 0.06 300)',
      destructive: 'oklch(0.64 0.21 25.33)',
      destructiveForeground: 'oklch(1.00 0 0)',
      border: 'oklch(0.37 0 0)',
      input: 'oklch(0.37 0 0)',
      ring: 'oklch(0.65 0.24 300)',
      radius: '0.375rem',
    },
  },
  search: {
    type: 'pagefind',
    // Optional: Maximum number of sub results per page
    maxSubResults: 3,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
};

export default config;
